import * as React from "react"
import * as Immutable from 'immutable'
import { BooleansOf } from "../../../utils/types";
import { snakeCase } from "lodash";
import { RentalAdvert } from "../../../types/types";
import BooleanList from "../../shared/advert/BooleanList";

type Props = {
  advert: RentalAdvert
  booleans: Immutable.OrderedSet<BooleansOf<RentalAdvert>>
}

export default (props: Props) : JSX.Element => (
  <BooleanList
    advert={props.advert}
    booleans={props.booleans}
    translate={(s) => I18n.t(`activerecord.attributes.rental_advert.${snakeCase(s)}`)}
  />
)
